/* eslint-disable no-case-declarations */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, {
    useCallback,
    useContext
} from 'react';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { FormModalPopover } from 'ml-components-platform-react';
import _ from 'lodash';
import modalPopoverUi from './MLHOValuableItemsSpecifiedPopover.metadata.json5';
import metadata from './MLHOValuableItemsSpecifiedComponent.metadata.json5';
import messages from './MLHOValuableItemsSpecifiedComponent.messages';

const SCHED_ITEM_TYPE = 'valuableItemsSpecified';
const DTO_PATH = 'metlife.edge.capabilities.common.plugin.dto.HOPValuableItemSpecifiedDTO';

function MLHOValuableItemsSpecifiedComponent(props) {
    const modalApi = useModal();
    const {
        items,
        defaultItem,
        readOnly,
        loading,
        parentAddItemSaveHandler,
        parentEditItemSaveHandler,
        parentRemoveItemHandler,
        addressFormatter,
        resetChosenTermAndChosenTermValue,
        formatOptionAvailableVals,
        onCovChange
    } = props;

    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();

    const editItemSaveHandler = useCallback((vm) => {
        return parentEditItemSaveHandler(vm, SCHED_ITEM_TYPE);
    }, [parentEditItemSaveHandler]);

    const addItemSaveHandler = useCallback((vm) => {
        return parentAddItemSaveHandler(vm, SCHED_ITEM_TYPE);
    }, [parentAddItemSaveHandler]);

    const getFirstJewelryItem = useCallback(() => {
        return items.find(element => _.get(element, "itemType") === "jewelry");
    });

    const getFirstCameraItem = useCallback(() => {
        return items.find(element => _.get(element, "itemType") === "cameras");
    });

    const isFirstJewelryItem = useCallback((item) => {
        const firstItem = getFirstJewelryItem();
        if (_.isUndefined(firstItem) || item.itemNumber.value === firstItem.itemNumber) {
            return true;
        }
        return false;
    });

    const isFirstCameraItem = useCallback((item) => {
        const firstItem = getFirstCameraItem();
        if (_.isUndefined(firstItem) || item.itemNumber.value === firstItem.itemNumber) {
            return true;
        }
        return false;
    });

    const getPopupProps = useCallback((vm, isEdit) => {

        const onItemTypeChange = (selectedOption, path) => {
            _.set(vm, path, selectedOption);
            if (selectedOption === "jewelry") {
                const first = getFirstJewelryItem();
                if (first != null && first.itemNumber != vm.itemNumber.value) {
                    const deductible = _.get(first, "deductible");
                    _.set(vm, "deductible", deductible);
                }
            } else if (selectedOption === "cameras") {
                const first = getFirstCameraItem();
                if (first != null && first.itemNumber != vm.itemNumber.value) {
                    const miscellaneousItems = _.get(first, "miscellaneousItems");
                    _.set(vm, "miscellaneousItems", miscellaneousItems);
                    setMiscellaneousItemsAmount(miscellaneousItems);
                } else if ((_.isUndefined(first) || first.itemNumber === vm.itemNumber.value) && _.isUndefined(vm.miscellaneousItems.value)) {
                    _.set(vm, "miscellaneousItems", false);
                    setMiscellaneousItemsAmount(false);
                }
            }
            onCovChange(undefined,undefined,undefined,false);
        };

        const setMiscellaneousItemsAmount = (selectedOption) => {
            if (selectedOption) {
                _.set(vm.value, "miscellaneousItemsAmount.amount", 500);
            } else {
                _.unset(vm.value, "miscellaneousItemsAmount.amount");
            }
        };

        const onMiscellaneousItemChange = (selectedOption, path) => {
            _.set(vm, path, selectedOption);
            setMiscellaneousItemsAmount(selectedOption);
            onCovChange(undefined,undefined,undefined,false);
        };

        return {
            title: messages.modalTitle,
            uiProps: modalPopoverUi.pageContent,
            actionBtnLabel: messages.continueBtn,
            viewModel: vm,
            getOverrideProps: () => {
                return {
                    itemTypeDropdownSelect: {
                        onValueChange: onItemTypeChange
                    },
                    jewelryContainer: {
                        visible: _.get(vm, "itemType.value.code") === "jewelry"
                    },
                    jewelryDeductibleDropdownSelect: {
                        readOnly: !isFirstJewelryItem(vm),
                        required: isFirstJewelryItem(vm)
                    },
                    appraisalDateInput: {
                        required: _.get(vm, "itemValue.value.amount") >= 25000
                    },
                    collectiblesContainer: {
                        visible: _.get(vm, "itemType.value.code") === "collectibles"
                    },
                    fineArtsContainer: {
                        visible: _.get(vm, "itemType.value.code") === "fine_arts_and_imported_or_specialty_rugs"
                    },
                    farmAndLandContainer: {
                        visible: _.get(vm, "itemType.value.code") === "farm_and_land_maintenance_equipment"
                    },
                    modelYearInput: {
                        maxYear: new Date().getFullYear() + 1
                    },
                    luxuryContainer: {
                        visible: _.get(vm, "itemType.value.code") === "luxury"
                    },
                    firearmsContainer: {
                        visible: _.get(vm, "itemType.value.code") === "firearms"
                    },
                    tablewareContainer: {
                        visible: _.get(vm, "itemType.value.code") === "silverware_goldware_platinumware_and_pewterware"
                    },
                    camerasContainer: {
                        visible: _.get(vm, "itemType.value.code") === "cameras"
                    },
                    miscellaneousItems: {
                        readOnly: !isFirstCameraItem(vm),
                        required: isFirstCameraItem(vm),
                        onValueChange: onMiscellaneousItemChange
                    },
                    musicalContainer: {
                        visible: _.get(vm, "itemType.value.code") === "musical_instruments"
                    }
                };
            },
            onSaveAction: isEdit ? editItemSaveHandler : addItemSaveHandler
        };
    }, [addItemSaveHandler, editItemSaveHandler]);

    const getDefaultScheduleItem = useCallback(() => {
        const defaultValuableItem = resetChosenTermAndChosenTermValue(defaultItem);
        return _.omit(defaultValuableItem, ['fixedID', 'publicID']);
    }, [defaultItem, resetChosenTermAndChosenTermValue]);

    const onAddItem = useCallback(() => {
        const isEdit = false;
        const defaultVal = getDefaultScheduleItem();
        const vm = viewModelService.create(defaultVal, 'pc', DTO_PATH);
        const componentProps = getPopupProps(vm, isEdit);

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }, [getDefaultScheduleItem, getPopupProps, viewModelService]);

    const onEditItem = useCallback((evt) => {
        const isEdit = true;
        const selectedItem = items[evt.index];
        const selectedItemVm = viewModelService.create(selectedItem, 'pc', DTO_PATH);
        const componentProps = getPopupProps(selectedItemVm, isEdit);

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }, [getPopupProps, items, viewModelService]);

    const onRemoveItem = useCallback((evt) => {
        parentRemoveItemHandler(evt.index, SCHED_ITEM_TYPE);
    }, [parentRemoveItemHandler]);

    const itemTypeTranslated = (item) => {
        return translator({
            id: `typekey.HOPValuableItemType_Ext.${item.itemType}`,
            defaultMessage: item.itemType
        });
    };

    const generateItemOverrides = useCallback(() => {
        const itemOverrides = items.map((item, itemIndex) => {
            return {
                [`actionRow${itemIndex}`]: {
                    visible: !readOnly,
                    className: loading ? 'cell disabled' : 'cell'
                },
                [`itemTypeContent${itemIndex}`]: {
                    content: itemTypeTranslated(item)
                },
                [`appraisalDateContent${itemIndex}`]: {
                    value: item.appraisalDate
                },
                [`itemValueContent${itemIndex}`]: {
                    value: item.itemValue
                }
            };
        });

        return Object.assign({}, ...itemOverrides);
    }, [addressFormatter, items, loading, readOnly]);

    const overrides = {
        stackTableDiv: {
            className: readOnly ? 'stack-table' : 'stack-table plain'
        },
        actionHeader: {
            visible: !readOnly
        },
        tableRowIterable: {
            data: items
        },
        bottomButtonContainer: {
            visible: !readOnly
        },
        addItemBtn: {
            visible: !readOnly,
            disabled: loading
        },
        ...generateItemOverrides()
    };


    const resolvers = {
        resolveCallbackMap: {
            onAddItem,
            onEditItem,
            onRemoveItem
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

MLHOValuableItemsSpecifiedComponent.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({})),
    defaultItem: PropTypes.shape({}),
    readOnly: PropTypes.bool,
    loading: PropTypes.bool,
    parentAddItemSaveHandler: PropTypes.func,
    parentEditItemSaveHandler: PropTypes.func,
    parentRemoveItemHandler: PropTypes.func,
    addressFormatter: PropTypes.func,
    resetChosenTermAndChosenTermValue: PropTypes.func
};

export default MLHOValuableItemsSpecifiedComponent;